import { render } from "./editarCompania.vue?vue&type=template&id=108338e4&scoped=true"
import script from "./editarCompania.vue?vue&type=script&lang=js"
export * from "./editarCompania.vue?vue&type=script&lang=js"

import "./editarCompania.vue?vue&type=style&index=0&id=108338e4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108338e4"]])

export default __exports__